module.exports = __webpack_public_path__ + "media/images/favicons/cbmaconnect-f51f590c18e67c9152c49524cd20e5578c00307c7138cdd50448388e86f2402d.ico";